export var INIT_FORM = 'INIT_FORM';
export var RESET_FORM_FIELDS = 'RESET_FORM_FIELDS';